import React from 'react';

const InputNumber = ({ label, register, errors, placeholder, validation }) => {
  return (
    <div className="mb-4">
      <div className="flex flex-col xl:flex-row justify-between items-start xl:items-center">
        <label className="block font-medium mb-2 md:mb-0">
          {label.includes('*') ? (
            <>
              {label.split('*')[0]}
              <span className="text-red">*</span>
            </>
          ) : (
            label
          )}
        </label>
        <input
          type="number"
          {...register(validation.name, validation.rules)}
          className={`px-3 mt-1 block w-full xl:max-w-[300px] h-[48px] border ${
            errors[validation.name] ? 'border-red' : 'border-borderGray'
          } rounded-md shadow-sm`}
          placeholder={placeholder}
        />
      </div>
      {errors[validation.name] && (
        <p className="text-red text-right mt-2">
          {errors[validation.name].message}
        </p>
      )}
    </div>
  );
};

export default InputNumber;
